import { CreditCardsSVGIcon, LifeInsuranceSVGIcon, LoansSVGIcon } from './assets'
import React from 'react'
import { SearchType } from '../SearchSummaryCard/internals/helpers'
import { getColorsFromSearchType } from 'experiences/search/utils/lib'

enum Products {
	PersonalLoans = 'Personal Loan',
	CreditCard = 'Credit Card',
	LifeInsurance = 'Life Insurance'
}

interface Props {
	product?: string
	state?: SearchType
}

export const ProductIcon = ({ product, state = SearchType.hasActiveOffers }: Props): JSX.Element => {
	const { primary, secondary } = getColorsFromSearchType(state)

	switch (product) {
		case Products.PersonalLoans:
			return <LoansSVGIcon color={primary} colorSecondary={secondary} />
		case Products.CreditCard:
			return <CreditCardsSVGIcon color={primary} colorSecondary={secondary} />
		case Products.LifeInsurance:
			return <LifeInsuranceSVGIcon color={primary} colorSecondary={secondary} />
		default:
			return <LoansSVGIcon color={primary} colorSecondary={secondary} />
	}
}
